import ProfilePage from '@/features/applications/[applicationId]/profile/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authed/companies/$companySlug/facilities/$facilitySlug/applications/$applicationId/profile',
)({
  component: ProfilePage,
})
